import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps } from "sonner";
import { useRouterState } from "@tanstack/react-router";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  
  // Use TanStack Router to check current route
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;
  
  // Check if we're on a kura start page by matching the route ID
  const isLotteryStartPage = currentPath.includes("/start") && currentPath.includes("/kura/");

  const baseStyle = {
    "--normal-bg": "var(--popover)",
    "--normal-text": "var(--popover-foreground)",
    "--normal-border": "var(--border)",
  } as React.CSSProperties;

  const centerStyle = isLotteryStartPage
    ? {
        ...baseStyle,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }
    : baseStyle;

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={centerStyle as React.CSSProperties}
      {...props}
    />
  );
};

export { Toaster };
